{
  "title": "Platform Administration Dashboard Overview",
  "description": "Understand what each section of the Platform Administration dashboard means, so you can quickly spot what needs your attention.",
  "headings": [
    "What You'll Accomplish",
    "Applies To",
    "Before You Start",
    "Steps",
    "What You'll See",
    "FAQ"
  ],
  "summary": "After reading this, you'll be able to tell whether the platform currently has any governance items needing attention, and know how to reach the matching detail list.",
  "roleNote": "Platform Administrator (Super Admin)",
  "prerequisites": [
    "You hold the super_admin role",
    "You're signed in to the Platform Administration console (/platform)"
  ],
  "pathLabel": "/platform (Overview)",
  "steps": [
    {
      "title": "1. \"Needs Your Attention\"",
      "description": "At the top of the page, currently-detected governance to-dos are summarized: pending competition-creation requests, a risk notice if there is currently only 1 active super admin, and judge-conflict-pairing notices. When there's nothing pending, a clear empty state is shown rather than blank space."
    },
    {
      "title": "2. Platform Scale",
      "description": "Shows active user count, total competitions (broken down by in-progress / ended or draft), and judge relationship count — all bounded, platform-wide aggregates, not a per-competition breakdown."
    },
    {
      "title": "3. Governance Status",
      "description": "Shows the number of suspended users and platform administrators; if you have permission to review competition requests, this also shows the pending request count."
    },
    {
      "title": "4. Operational Health",
      "description": "Shows registered team count and judging completion rate — bounded, platform-wide aggregates, not a per-competition breakdown."
    },
    {
      "title": "5. Quick Links and Recent Activity",
      "description": "Below the metric cards are four quick links — Users / Competition Requests / Judges / Audit; at the bottom, \"Recent Important Governance Activity\" hides noisy form-field-level edit records by default, showing only significant governance events."
    }
  ],
  "afterward": [
    "You can click through from the \"Needs Your Attention\" card straight to the matching filtered/sorted list page",
    "You can use the left navigation to switch to Users, Judge Governance, Administrators, Competitions, Audit Log, and other pages"
  ],
  "nextSteps": "If \"Needs Your Attention\" shows a pending competition request, click through to \"Competition Requests\" to review it.",
  "faq": [
    {
      "q": "How often do the dashboard numbers update?",
      "a": "Every metric is computed live on each page load — there's no caching and no separate table storing these aggregates. Reload the page to see the latest values."
    },
    {
      "q": "Why can't I see the Platform Administration console after signing in?",
      "a": "This is expected: registering and signing in by themselves grant no platform permissions. /platform is accessible only to super_admin accounts; if you're the very first user of a fresh deployment, you first need to complete the Bootstrap process to become the initial super_admin."
    }
  ]
}
